module.exports = __webpack_public_path__ + "static/media/upload.a46ef86c.svg";